<header class="modal-header">
    <h4 class="modal-title">Kundeaccept til godkendelse</h4>
    <button (click)="onClose()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</header>


<section class="modal-body">
    <table *ngIf="regnskabsaarTilGodkendelse$ | async as regnskabsaarTilGodkendelse"
           class="table table-hover table-striped table-sm">
        <thead>
        <th>Kundenr</th>
        <th>Firma</th>
        <th>Navn</th>
        <th>Regnskabsår</th>
        <th>Anmodning</th>
        </thead>
        <tbody>
        <tr *ngFor="let item of regnskabsaarTilGodkendelse"
            class="clickable"
            (click)="onGotoGodkendelse(item)">
            <td>{{item?.glkundenr}}</td>
            <td>{{item.navn1}}</td>
            <td>{{item.navn2}}</td>
            <td>{{item.regnskabsaar}}</td>
            <td>{{item.anmodetTid | date:'dd-MM-yyyy'}} - {{item.anmodetAf}}</td>
        </tr>
        </tbody>
    </table>
</section>
